import { ref, onBeforeUnmount, onDeactivated } from 'vue';

export function useTimerManager() {
  const timeouts = ref([]);
  const intervals = ref([]);

  const registerTimeout = (callback, timeInMs) => {
    const timeout = setTimeout(callback, timeInMs);
    timeouts.value.push(timeout);

    return timeout;
  };

  const registerInterval = (callback, timeInMs) => {
    const interval = setInterval(callback, timeInMs);
    intervals.value.push(interval);

    return interval;
  }

  const cleanup = () => {
    timeouts.value.forEach(timeout => {
      clearTimeout(timeout);
    });
    timeouts.value = [];

    intervals.value.forEach(interval => {
      clearInterval(interval);
    });
    intervals.value = [];
  }

  onBeforeUnmount(() => {
    cleanup();
  });

  onDeactivated(() => {
    cleanup();
  });

  return {
    registerTimeout,
    registerInterval,
  };
}
